<template>
  <TableLayout v-permissions="['template:field:type:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="大类" prop="category">
        <el-select v-model="searchForm.category" placeholder="请选择大类" clearable @change="search">
          <el-option value="TEXT" label="文本"/>
          <el-option value="NUMBER" label="数字"/>
          <el-option value="IMAGE" label="图片"/>
          <el-option value="OBJECT" label="对象"/>
        </el-select>
      </el-form-item>
      <el-form-item label="类型名称" prop="label">
        <el-input v-model="searchForm.label" placeholder="请输入类型名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="数据规则" prop="dataRule">
        <el-select v-model="searchForm.dataRule" placeholder="请选择数据规则" clearable @change="search">
          <el-option value="INPUT" label="自行录入"/>
          <el-option value="RULE" label="自定义规则"/>
        </el-select>
      </el-form-item>
      <el-form-item label="ID" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入ID" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['template:field:type:create', 'template:field:type:delete']">
        <li><el-button type="primary" @click="$refs.operaTemplateFieldTypeWindow.open('新建模版字段类型')" icon="el-icon-plus" v-permissions="['template:field:type:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['template:field:type:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="记录ID" min-width="100px"></el-table-column>
        <el-table-column prop="label" label="类型名称" min-width="100px"></el-table-column>
        <el-table-column prop="variable" label="类型变量" min-width="100px"></el-table-column>
        <el-table-column prop="category" label="大类" min-width="100px">
          <template slot-scope="{row}">{{ row.category | categoryText }}</template>
        </el-table-column>
        <el-table-column prop="inputFrom" label="录入方式" min-width="100px">
          <template slot-scope="{ row }">{{row.inputFrom | inputFromText}}</template>
        </el-table-column>
        <el-table-column prop="dataRule" label="数据来源" min-width="100px">
          <template slot-scope="{row}">{{ row.dataRule | dataRuleText }}</template>
        </el-table-column>
        <el-table-column prop="dataRuleConfig" label="规则表达式" min-width="160px"></el-table-column>
        <el-table-column prop="createUserInfo.realname" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
        <el-table-column prop="updateUserInfo.realname" label="更新人" min-width="100px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="140px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['template:field:type:update', 'template:field:type:delete'])"
          label="操作"
          min-width="200"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" v-if="row.dataRule === 'INPUT'" @click="$refs.fieldTypeDataTableWindow.open(row)" icon="el-icon-edit" v-permissions="['template:field:type:update']">配置数据</el-button>
            <el-button type="text" @click="$refs.operaTemplateFieldTypeWindow.open('编辑模版字段类型', row)" icon="el-icon-edit" v-permissions="['template:field:type:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['template:field:type:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaTemplateFieldTypeWindow ref="operaTemplateFieldTypeWindow" @success="handlePageChange"/>
    <!-- 配置数据 -->
    <FieldTypeDataTableWindow ref="fieldTypeDataTableWindow"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaTemplateFieldTypeWindow from '@/components/template/OperaTemplateFieldTypeWindow'
import FieldTypeDataTableWindow from '@/components/template/FieldTypeDataTableWindow'
export default {
  name: 'TemplateFieldTypeList',
  extends: BaseTable,
  components: { FieldTypeDataTableWindow, TableLayout, Pagination, OperaTemplateFieldTypeWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: null,
        category: '',
        label: '',
        dataRule: ''
      }
    }
  },
  filters: {
    // 大类
    categoryText (value) {
      if (value === 'IMAGE') {
        return '图片'
      }
      if (value === 'TEXT') {
        return '文本'
      }
      if (value === 'NUMBER') {
        return '数字'
      }
      if (value === 'OBJECT') {
        return '对象'
      }
      return '未知大类'
    },
    // 数据来源
    dataRuleText (value) {
      if (value === 'INPUT') {
        return '自行输入'
      }
      if (value === 'RULE') {
        return '自定义规则'
      }
      return '未知来源'
    }
  },
  created () {
    this.config({
      module: '模版字段类型',
      api: '/template/fieldType',
      'field.id': 'id',
      'field.main': 'label'
    })
    this.search()
  }
}
</script>
